module.exports = (__webpack_require__(2))("./core/appHistory.js");


//////////////////
// WEBPACK FOOTER
// delegated ./core/appHistory.js from dll-reference base
// module id = 92
// module chunks = 22